// Temporary local-dev wiring: link to local developers when the blog is on localhost.
function isLocalDevHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function developersSiteUrl() {
  if (typeof window !== 'undefined' && isLocalDevHost(window.location.hostname)) {
    return process.env.GATSBY_DEVELOPERS_URL || 'http://localhost:3000';
  }

  return 'https://developers.soundcloud.com';
}
